import { computed, ComputedRef } from "vue"
import store from "@/vue/planning/store/store"
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import availableFlightPackCodes from "@/vue/planning/computed/availableFlightPackCodes"

const hasTransportOptions: ComputedRef<boolean> = computed(() => {
	const locale = store.getters.locale
	if (locale === "en_US") {
		return availableFlightPackCodes.value.length > 0
	}
	return availableTransportPackCodes.value.length > 0
})

export default hasTransportOptions
